// src/utils/services/AdvancedMD/ehrNotesQuery.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/advancedmd/ehrnotes-query/search`;

// helper: mm/dd/yyyy hh:mm:00 AM/PM
const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
const toUsDatetime = (d) => {
  const h = d.getHours();
  const hour12 = ((h + 11) % 12) + 1;
  const ampm = h >= 12 ? "PM" : "AM";
  return `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()} ${pad2(
    hour12
  )}:${pad2(d.getMinutes())}:00 ${ampm}`;
};

// lista 1:1 con Swagger (sin tocar nombres)
const INCLUDE_FIELD_NAMES = [
  "location","location2","location1","ReasonforAppointment",
  "Vitals_Weight","Vitals_Height","Vitals_BMI","Vitals_Temperature","Vitals_Pulse","Vitals_O2SatRA",
  "Vitals_BP_SystolicPrev","Vitals_BP_DiastolicPrev","Vitals_BP_Systolic1","Vitals_BP_Diastolic1","Vitals_BP_Option1","Vitals_BP_Location1",
  "HistoryofPresentIllness","HistoryofPresentIllness1","Allmedicationsreviewedandreconciled","CurrentMedications",
  "PMH","PMH2",
  "Constitutional","chills","fever","lightheadedness","ChangesinAppetite","Fatigue","WeightChange",
  "Ophthalmologic","VisionChanges","Doublevision","EyePain",
  "ENT","Decreasedhearing","Ringingintheears","EarPain","Nose1","NoseBleed","NasalCongestion","sinuspain","Throat1","SoreThroat","Difficultyswallowing",
  "Endocrine","Coldintolerance","Excessivethirst","frequenturination","Heatintolerance","excessivesweating",
  "Respiratory","Shortnessofbreath","Wheezing","Hemoptysis","Cough","sputumproduction",
  "Cardiovascular","Chestpain","ChestpressureorChestdiscomfort","Palpitations","Irregularheartbeat","difficultylayingflat","dyspneaonexertion","Claudication",
  "Gastrointestinal","Abdominalpain","Nausea","vomitting","changeinbowelhabits","anorexia","BloodinStool","Diarrhea","Heartburn",
  "Genitourinary","bloodintheurine","difficultyurinating","paininthelowerback",
  "Musculoskeletal1","painfuljoints","Swollenjoints","Cervical","Thoraxic","Lumbar",
  "Neurologic1","Paralysis","Seizures","TinglingNumbness","Dizziness1","weakness","Newonsetheadache","Difficultyspeaking","Headache","Dizziness","lossofstrength","Memoryloss","abnormality",
  "Psy","Suicidalhomicidalthoughts","DifficultySleeping",
  "GeneralAppearance","Finding","EyesBL","Finding1","Ears","Finding2","Nose","Finding3","OralCavity","Finding4","Throat","Finding5",
  "NeckThyroid","Finding6","Heart","Finding7","Lungs","Finding8","Breast","Finding08","Abdomen","Finding9","Pelvic","Finding09","back","Finding10",
  "Musculoskeletal","Finding11","Skin","Finding12","Neurologic","Finding13","Extremities","Finding14","Psychiatric","Finding15",
  "PHQ9_1_1","PHQ9_2_1","PHQ9scorereviewed","Assessments","Treatment","FollowUp",
];

// Body 100% igual al de Swagger (siempre con @templateid)
function buildExactPayload({ patientId, templateId }) {
  const msgtime = toUsDatetime(new Date()); // o usa el fijo del ejemplo si prefieres
  return {
    ppmdmsg: {
      "@action": "getehrnotes",
      "@class": "api",
      "@msgtime": msgtime,
      "@nocookie": "0",
      "@patientid": String(patientId),
      "@templateid": String(templateId), // <- OBLIGATORIO aquí

      patientnote: {
        "@templatename": "TemplateName",
        "@notedatetime": "NoteDatetime",
        "@username": "UserName",
        "@signedbyuser": "SignedByUser",
        "@reviewedbyuser": "ReviewedByUser",
        "@confidential": "Confidential",
        "@printedat": "PrintedAt",
        "@comments": "comments",
      },
      sign: { "@username": "FullName", "@signeddat": "SignDatetime" },
      page: { "@pagename": "PageName" },
      field: { "@ordinal": "Ordinal", "@name": "FieldName", "@value": "Value" },
      includefieldlist: {
        includefield: INCLUDE_FIELD_NAMES.map((n) => ({ "@name": n })),
      },
    },
  };
}

// API usada por ClinicalNotesList
export async function getEhrNotes({ patientId, templateId }) {
  // si no pasas templateId, aquí forzamos el requerido del vendor:
  if (!templateId) {
    // ⚠️ pon aquí el que usas en Swagger:
    templateId = "100056147";
  }

  const payload = buildExactPayload({ patientId, templateId });

  try {
    const res = await axios.post(API_URL, payload, {
      headers: { "Content-Type": "application/json" },
      transformRequest: [(data) => JSON.stringify(data)], // manda JSON plano, igual que Swagger
      validateStatus: () => true, // para ver el cuerpo si falla
    });

    if (res.status >= 200 && res.status < 300) return res.data;

    console.error("Backend devolvió error:", res.status, res.data);
    throw new Error(`Backend ${res.status}`);
  } catch (err) {
    // imprime el detalle real (si viene)
    console.error("getEhrNotes error →", {
      status: err?.response?.status,
      data: err?.response?.data,
    });
    throw err;
  }
}
